module.exports = __webpack_public_path__ + "static/media/katarzyna-grabowska-sRAWQyoUiVQ-unsplash.9a6b2cef.jpg";